import React, { useState, useEffect, useContext } from "react";
import CommonListHeader from 'components/layout/list/header'
import CommonNavigatorHeader from "components/layout/list/navigation";
import CommonTableContainer from 'components/layout/list/table'
import { usePrivateDBListQuery } from "services/privatedb";
import { v4 as uuidv4 } from 'uuid'
import { useParams } from "react-router-dom";

const PrivateDBMain = () => {
    let { filter } = useParams();
    let { } = useParams();
    const [page, setPage] = useState(0)
    const searchOnChange = () => {
        console.log('search on change');
    }

    const tableTitle = [
        { md: 5, value: 'DOT' },
        { md: 5, value: 'Case Name', sort: 'case_name' },
        { md: 2, value: 'Tire Brand/Type' },
        { md: 2, value: 'P/LT/Eur-Metric' },
        { md: 5, value: 'Tire Size' },

        { md: 5, value: 'Speed Rating' },
        { md: 5, value: 'Load Range' },
        { md: 5, value: 'Construction' },
        { md: 5, value: 'Failure Mode' },
        { md: 5, value: 'Punctures/Repairs' },
        { md: 1, value: 'Status' },

    ]

    const [criteria, setCriteria] = useState({
        filter: filter,
        page: page,
        sort: 'case_name.keyword',
        order: 'desc',
        searchKeyword: '',
    });

    const { activePrivateDBList, activeCount, activeStatus, activeLoading, fetching } = usePrivateDBListQuery({ criteria: criteria },
        {
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                activePrivateDBList: data?.hits?.hits?.map(d => d._source) || [],
                activeCount: data?.hits?.total?.value || 0,
                activeStatus: status,
                activeLoading: isLoading,
                fetching: isFetching
            })
        }
    );



    return (
        <React.Fragment>
            <CommonListHeader value={{ title: "TSA+ DB", description: "List of all Records", link: '/privatedb/create', buttonName: "Create" }} />
            <CommonNavigatorHeader value={{
                total: activeCount,
                search: {
                    label: '',
                    placeHolder: '',
                    keyword: '',
                    searchOnChange: searchOnChange
                },
                setPage: setPage,
                page: page,
                setCriteria: setCriteria,
                criteria: criteria
            }} />
            <CommonTableContainer
                value={{
                    tableTitle: tableTitle,
                    sort: 'privateDB Id',
                    loadRow: [0, 1, 2, 3, 4, 5, 6, 7, 8],
                    loadColumn: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                    activeList: activePrivateDBList,
                    type: 'privateDB',
                    fulfilled: activeStatus
                }}
            />
        </React.Fragment>
    );
}

export default PrivateDBMain;